module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Chelsea.png
// module id = 2080
// module chunks = 4